import React from "react";
import Button from "../../components/staff/Button";

interface CancelBillingDocModalProps {
  isOpen: boolean;
  docType: "invoice" | "payment";
  docRef: string;
  linkedPaymentCount?: number;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function CancelBillingDocModal({
  isOpen,
  docType,
  docRef,
  linkedPaymentCount = 0,
  isSubmitting = false,
  onCancel,
  onConfirm,
}: CancelBillingDocModalProps): React.ReactElement | null {
  if (!isOpen) {
    return null;
  }

  const docLabel = docType === "invoice" ? "invoice" : "payment";
  const keepLabel =
    docType === "invoice" ? "Keep Invoice" : "Keep Payment";
  const confirmLabel =
    docType === "invoice" ? "Cancel Invoice" : "Cancel Payment";

  return (
    <div className="fixed inset-0 z-[1000] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black bg-opacity-80"
        onClick={isSubmitting ? undefined : onCancel}
      />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="mb-4 font-decimal text-xl font-medium text-Default">
            Cancel {docType === "invoice" ? "Invoice" : "Payment"}
          </h2>

          <p className="mb-4 text-gray-font">
            Are you sure you want to cancel this {docLabel}{" "}
            <span className="font-semibold">{docRef}</span>? The record will be
            kept but will no longer count toward billing totals.
          </p>

          {docType === "invoice" && linkedPaymentCount > 0 && (
            <p className="mb-4 text-gray-font">
              {linkedPaymentCount === 1
                ? "1 associated payment will also be cancelled."
                : `${linkedPaymentCount} associated payments will also be cancelled.`}
            </p>
          )}

          <div className="flex justify-end gap-4">
            <Button
              text={keepLabel}
              color="secondary"
              variant="outlined"
              size="fixed"
              onClick={onCancel}
              disabled={isSubmitting}
            />
            <Button
              text={isSubmitting ? "Cancelling..." : confirmLabel}
              color="secondary"
              variant="filled"
              size="fixed"
              onClick={onConfirm}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
